import axios from 'axios';

const baseUrl = process.env.BASE_SERVER_ADDRESS;

export const FooterPageQuery = async (page: string) => {
  return await axios.get(`${baseUrl}/page/get/${page}`);
};
